import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63c04ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = { class: "card card-outline card-primary" }
const _hoisted_4 = { class: "card-header text-center" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7 mt-3" }, null, -1))
const _hoisted_10 = { class: "col-5 mt-3" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 登入 ")

export function render(_ctx, _cache) {
  const _component_app_background_images = _resolveComponent("app-background-images")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_checkbox = _resolveComponent("app-checkbox")
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_background_images),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.siteTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.loginByAuth && _ctx.loginByAuth(...args)), ["prevent"]))
          }, [
            _createVNode(_component_app_input, {
              icon: "person",
              class: "mb-3",
              type: "text",
              placeholder: "工号",
              autocomplete: "on",
              modelValue: _ctx.loginInfo.usercode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.loginInfo.usercode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              icon: "key",
              class: "mb-3",
              type: "password",
              placeholder: "密码",
              autocomplete: "off",
              modelValue: _ctx.loginInfo.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.loginInfo.password) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_app_checkbox, {
                  type: "custom",
                  label: "记住账号",
                  modelValue: _ctx.loginInfo.rememberMe,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.loginInfo.rememberMe) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_app_checkbox, {
                  class: "text-right",
                  type: "custom",
                  label: "自动登入",
                  modelValue: _ctx.loginInfo.autoLogin,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.loginInfo.autoLogin) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_app_button, {
                  class: "btn-primary",
                  type: "submit",
                  block: "true",
                  loading: _ctx.isAuthLoading
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}